import { createContext } from "react";

export const PokeContext = createContext()